<template>
    <div v-if="pairs.length" class="od-details">
        <button
            type="button"
            class="od-details__toggle"
            :aria-expanded="open ? 'true' : 'false'"
            @click="open = !open"
        >
            {{ label }}
            <od-icon name="chevron-down" class="od-details__chevron" :class="{ 'is-open': open }" />
        </button>
        <dl v-if="open" class="od-details__list">
            <template v-for="(pair, index) in pairs" :key="pair[0] + '-' + index">
                <dt class="od-details__key">{{ pair[0] }}</dt>
                <dd class="od-details__value">
                    <span class="od-details__text od-mono">{{ pair[1] }}</span>
                    <od-copy-button :value="String(pair[1])" />
                </dd>
            </template>
        </dl>
    </div>
</template>

<script>
import OdCopyButton from './OdCopyButton.vue';
import OdIcon from './OdIcon.vue';

/** Collapsed-by-default disclosure for technical key/value pairs. */
export default {
    name: 'OdCollapsibleDetails',
    components: { OdCopyButton, OdIcon },
    props: {
        pairs: { type: Array, required: true },
        label: { type: String, default: 'Dettagli tecnici' },
    },
    data() {
        return { open: false };
    },
};
</script>
